// extracted by mini-css-extract-plugin
export default {"footer":"FooterContent_footer__c4163"};